(() => {
  const initSlider = (slider) => {
    if (slider.dataset.cswInitialised === 'true') return;
    slider.dataset.cswInitialised = 'true';

    const track = slider.querySelector('[data-csw-track]');
    const prev = slider.querySelector('[data-csw-prev]');
    const next = slider.querySelector('[data-csw-next]');
    const dotsWrap = slider.querySelector('[data-csw-dots]');
    if (!track || !dotsWrap) return;

    const slides = Array.from(track.children);
    const showArrows = slider.dataset.showArrows !== 'false';
    const showDots = slider.dataset.showDots !== 'false';
    const pauseOnHover = slider.dataset.pauseOnHover !== 'false';

    if (!showArrows) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
    }

    if (!showDots) dotsWrap.style.display = 'none';

    if (slides.length <= 1) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      dotsWrap.style.display = 'none';
      return;
    }

    let index = 0;
    let timer = null;
    const autoplay = slider.dataset.autoplay === 'true';
    const interval = Number(slider.dataset.interval || 4500);

    const makeDots = () => {
      dotsWrap.innerHTML = '';
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'csw-slider-dot';
        dot.setAttribute('aria-label', `Go to material image ${i + 1}`);
        dot.addEventListener('click', () => {
          goTo(i);
          restart();
        });
        dotsWrap.appendChild(dot);
      });
    };

    const updateDots = () => {
      Array.from(dotsWrap.children).forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };

    const goTo = (newIndex) => {
      index = (newIndex + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      updateDots();
    };

    const detectIndex = () => {
      let closest = 0;
      let distance = Infinity;
      slides.forEach((slide, i) => {
        const diff = Math.abs(slide.offsetLeft - track.scrollLeft);
        if (diff < distance) {
          distance = diff;
          closest = i;
        }
      });
      if (closest !== index) {
        index = closest;
        updateDots();
      }
    };

    const start = () => {
      if (!autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = window.setInterval(() => goTo(index + 1), Math.max(interval, 2000));
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const restart = () => {
      stop();
      start();
    };

    makeDots();
    updateDots();

    if (prev) prev.addEventListener('click', () => { goTo(index - 1); restart(); });
    if (next) next.addEventListener('click', () => { goTo(index + 1); restart(); });

    track.addEventListener('scroll', () => window.requestAnimationFrame(detectIndex), { passive: true });

    if (pauseOnHover) {
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
    }

    start();
  };

  const initFaq = (root = document) => {
    root.querySelectorAll('.csw-faq-list details').forEach((detail) => {
      if (detail.dataset.cswFaqInitialised === 'true') return;
      detail.dataset.cswFaqInitialised = 'true';

      const summary = detail.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = detail.hasAttribute('open');
        if (isOpen) {
          detail.classList.add('is-closing');
          window.setTimeout(() => {
            detail.removeAttribute('open');
            detail.classList.remove('is-closing');
          }, 260);
        } else {
          detail.setAttribute('open', '');
        }
      });
    });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-csw-slider]').forEach(initSlider);
    initFaq(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();


/* ===== 08 CSW Kit visual redesign v2 ===== */
/* 08 CSW Kit: optional native-scroll controls. No product form, app or checkout changes. */
(() => {
  'use strict';
  if (window.CSWKitVisualV1) {
    window.CSWKitVisualV1.mount(document);
    return;
  }

  const instances = new Map();
  const mobile = window.matchMedia('(max-width: 749px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  class KitRail {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-csw-kit-items]');
      this.nav = root.querySelector('[data-csw-kit-nav]');
      this.prev = root.querySelector('[data-csw-kit-prev]');
      this.next = root.querySelector('[data-csw-kit-next]');
      this.abort = new AbortController();
      this.frame = 0;
      this.refresh = this.refresh.bind(this);
      this.schedule = this.schedule.bind(this);
      if (!this.track) return;
      this.items = Array.from(this.track.children);
      const opts = { signal: this.abort.signal };
      this.track.addEventListener('scroll', this.schedule, { ...opts, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !this.active) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight') !== rtl ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : this.items.length - 1);
        }
      }, opts);
      this.prev?.addEventListener('click', () => this.move(-1), opts);
      this.next?.addEventListener('click', () => this.move(1), opts);
      window.addEventListener('resize', this.schedule, { ...opts, passive: true });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.track);
      }
      this.refresh();
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
    }
    refresh() {
      if (!this.track || !this.root.isConnected) return;
      this.active = mobile.matches && this.root.dataset.mobileLayout === 'slider' &&
        this.track.clientWidth > 0 && this.track.scrollWidth > this.track.clientWidth + 2;
      if (this.nav) this.nav.hidden = !this.active;
      if (!this.active) {
        this.track.removeAttribute('tabindex');
        return;
      }
      this.track.tabIndex = 0;
      const viewport = this.track.getBoundingClientRect();
      const first = this.items[0]?.getBoundingClientRect();
      const last = this.items[this.items.length - 1]?.getBoundingClientRect();
      if (!first || !last) return;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const atStart = rtl ? first.right <= viewport.right + 2 : first.left >= viewport.left - 2;
      const atEnd = rtl ? last.left >= viewport.left - 2 : last.right <= viewport.right + 2;
      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;
    }
    move(delta) {
      if (!this.active) return;
      const viewport = this.track.getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      let nearest = 0;
      let shortest = Infinity;
      this.items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const distance = Math.abs(rtl ? rect.right - viewport.right : rect.left - viewport.left);
        if (distance < shortest) { shortest = distance; nearest = index; }
      });
      this.go(Math.max(0, Math.min(this.items.length - 1, nearest + delta)));
    }
    go(index, instant = false) {
      if (!this.active || !this.items[index]) return;
      const viewport = this.track.getBoundingClientRect();
      const rect = this.items[index].getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const delta = rtl ? rect.right - viewport.right : rect.left - viewport.left;
      this.track.scrollBy({ left: delta, behavior: instant || reduced.matches ? 'instant' : 'smooth' });
      this.schedule();
    }
    destroy() {
      this.abort.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  }

  function roots(scope) {
    const result = Array.from(scope.querySelectorAll('[data-csw-kit]'));
    if (scope.matches?.('[data-csw-kit]')) result.unshift(scope);
    return result;
  }
  function mount(scope) {
    for (const [root, instance] of instances) {
      if (!root.isConnected) { instance.destroy(); instances.delete(root); }
    }
    roots(scope).forEach((root) => {
      if (!instances.has(root)) instances.set(root, new KitRail(root));
      else instances.get(root).schedule();
    });
  }
  window.CSWKitVisualV1 = { mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [root, instance] of instances) {
      if (event.target.contains(root)) { instance.destroy(); instances.delete(root); }
    }
  });
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest?.('.cswk__item');
    if (!item) return;
    const root = item.closest('[data-csw-kit]');
    const instance = instances.get(root);
    if (instance) { instance.refresh(); instance.go(instance.items.indexOf(item), true); }
  });
})();
